const THEMES_IMAGE_PATH = '/ui-router/images/resume-builder/themes';
const COLORED_THEME_IMAGE = `${THEMES_IMAGE_PATH}/colored`;
const BLACK_WHITE_THEME_IMAGE = `${THEMES_IMAGE_PATH}/black-white`;

export const RB_THEME = {
  COLOR_THEME_1: 'ColorTheme1',
  COLOR_THEME_2: 'ColorTheme2',
  COLOR_THEME_3: 'ColorTheme3',
  COLOR_THEME_4: 'ColorTheme4',
  COLOR_THEME_5: 'ColorTheme5',
  TEXT_THEME_1: 'TextTheme1',
  TEXT_THEME_2: 'TextTheme2',
  TEXT_THEME_3: 'TextTheme3',
  TEXT_THEME_4: 'TextTheme4',
  TEXT_THEME_5: 'TextTheme5',
  TEXT_THEME_6: 'TextTheme6',
  TEXT_THEME_7: 'TextTheme7',
};

export const RB_THEME_INFO = {
  [RB_THEME.COLOR_THEME_1]: {
    image: `${COLORED_THEME_IMAGE}/1.1.webp`,
    name: 'Functional flair',
    intro: 'A clean-cut layout that appeals to a traditional eye with a modern twist.',
  },
  [RB_THEME.COLOR_THEME_2]: {
    image: `${COLORED_THEME_IMAGE}/2.1.webp`,
    name: 'Radiant professional',
    intro: 'A pop of color to attract attention while still being grounded and organized.',
  },
  [RB_THEME.COLOR_THEME_3]: {
    image: `${COLORED_THEME_IMAGE}/3.1.webp`,
    name: 'Outside the box',
    intro: 'A design of playful patterns to frame the focal point on your career accomplishments.',
  },
  [RB_THEME.COLOR_THEME_4]: {
    image: `${COLORED_THEME_IMAGE}/4.1.webp`,
    name: 'Lively elegance',
    intro: 'A seamless presentation of your professional life with a touch of wholesome green.',
  },
  [RB_THEME.COLOR_THEME_5]: {
    image: `${COLORED_THEME_IMAGE}/5.1.webp`,
    name: 'Sleek traditional',
    intro: 'A balanced catalog of professional accomplishments that never goes out of style.',
  },
  [RB_THEME.TEXT_THEME_5]: {
    image: `${BLACK_WHITE_THEME_IMAGE}/5.1.webp`,
    name: 'Polished confidence',
    intro: 'A traditionalist look that exudes the making of a seasoned professional.',
  },
  [RB_THEME.TEXT_THEME_2]: {
    image: `${BLACK_WHITE_THEME_IMAGE}/2.1.webp`,
    name: 'Timeless basic',
    intro: 'An upfront and simple approach that intrigues all types of employers.',
  },
  [RB_THEME.TEXT_THEME_1]: {
    image: `${BLACK_WHITE_THEME_IMAGE}/1.1.webp`,
    name: 'Delicate vigor',
    intro: 'A dynamic layout with poignant organization and charming simplicity.',
  },
  [RB_THEME.TEXT_THEME_7]: {
    image: `${BLACK_WHITE_THEME_IMAGE}/7.1.webp`,
    name: 'Simple standard',
    intro: 'An unassuming attractiveness to convey experience without the frills.',
  },
  [RB_THEME.TEXT_THEME_6]: {
    image: `${BLACK_WHITE_THEME_IMAGE}/6.1.webp`,
    name: 'The strategist',
    intro: 'A reliable format with a corporate demeanor.',
  },
  [RB_THEME.TEXT_THEME_3]: {
    image: `${BLACK_WHITE_THEME_IMAGE}/3.1.webp`,
    name: 'Classic & dependable',
    intro: 'A basic look and structure that keeps the focus on your skills and background.',
  },
  [RB_THEME.TEXT_THEME_4]: {
    image: `${BLACK_WHITE_THEME_IMAGE}/4.1.webp`,
    name: 'Focused composure',
    intro: 'A fixated outline with bold section placements for information emphasis.',
  },
};
